import { render, staticRenderFns } from "./editPurchase.vue?vue&type=template&id=1024ed86&scoped=true&"
import script from "./editPurchase.vue?vue&type=script&lang=js&"
export * from "./editPurchase.vue?vue&type=script&lang=js&"
import style0 from "./editPurchase.vue?vue&type=style&index=0&id=1024ed86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024ed86",
  null
  
)

export default component.exports